export default __webpack_public_path__ + "locales/tr/ChangeEmailDialog.json?hash=ea9f7941017cf3d6446998823f2cfb76";